import styled, { css } from 'styled-components'
import {
  ShowPassword as ShowPasswordDefault,
  HidePassword as HidePasswordDefault,
} from '~components'

const EyeIcon = css`
  position: absolute;
  cursor: pointer;
  transform: translate(calc(-100% - ${({ theme }) => theme.spacing.km3}), -50%);
  top: 50%;
`

export const ShowPassword = styled(ShowPasswordDefault).attrs({
  'aria-label': 'show-password',
})`
  ${EyeIcon}
`

export const HidePassword = styled(HidePasswordDefault).attrs({
  'aria-label': 'hide-password',
})`
  ${EyeIcon}
`
